module.exports = __webpack_public_path__ + "static/media/Attic24.a3017d10.png";